import cognitoAuth from '@/plugins/cognito'
import 'isomorphic-fetch'
const axios = require("axios")

//let gql_endpoint = process.env.GQL_ENDPOINT
let gql_endpoint = process.env.GQL_V2_ENDPOINT
let read_gql_endpoint = process.env.READGQL_ENDPOINT

function protectedContent (endpoint, header_structure, gqlquery, cb) {
  console.log("in protected, query is:", gqlquery)
  
    axios({
      url: endpoint,
      method: 'post',
      headers: JSON.parse(header_structure),
      data: {
        query: gqlquery
      }
    }).then((result) => {
      if(result.status  === 200){
        return cb(null, result.data)
      }
      console.log("error:",result.status)
      return cb(result, null)
    }).catch(error => {
      console.log(error)
      return cb(error, null)
   })
  
  /*
  let variables={}
  fetch('https://development-latest.presageanalytics.com/graphql', {
    method: 'post',
    mode: 'cors',
    body: JSON.stringify({ query: `query sessioner{session{userAccountId userName}}` }),
    headers: {
      'Accept': 'application/json',
      'auth-token': '81429634-0ff9-11ec-9322-caab0a0000dc',
    }
  }).then(response => {
    console.log("response:", response)
    if (response.status === 200) {
      response.json().then((r) => {
        return cb(null, r)
      })
    }
  }).catch(err => {
    console.log("error!:", err)
    return cb(err)
  })
  */
}

function anonymousQuery (query, variables, cb) {
    fetch(gql_endpoint, {
      method: 'post',
      mode: 'cors',
      body: JSON.stringify({ query: query, variables: variables }),
      headers: {
        'Accept': 'application/json',
      }
    }).then(response => {
      if (response.status === 200) {
        response.json().then((r) => {
          return cb(null, r)
        })
      }
    }).catch(err => {
      return cb(err)
    })
}

function authedQuery (query, variables, cb) {
  cognitoAuth.getIdToken(function (err, jwttoken) {
    if (err) {
      alert(JSON.stringify(err));
      return cb(err)
    }
    var headers = new Headers({
      'Accept': 'application/json',
      'Authorization': `Bearer ${jwttoken}`
    })
    if(jwttoken==null){
      anonymousQuery(query, variables, cb);
      return;
    }
    //console.log("jwttoken:", jwttoken)
    fetch(gql_endpoint, {
      method: 'post',
      mode: 'cors',
      body: JSON.stringify({ query: query, variables: variables }),
      headers: {
        'Accept': 'application/json',
        'Authorization': `Bearer ${jwttoken}`
      }
    }).then(response => {
      if (response.status === 200) {
        response.json().then((r) => {
          return cb(null, r)
        })
      }
    }).catch(err => {
      return cb(err)
    })
  })
}

export default class gqlV2Query {
  authorizedContentCheck(endpoint, header, query, cb){
    return protectedContent(endpoint, header, query, cb)
  }
  deleteCategory (id, cb) {
    var query = `
    mutation delete_category($id: uuid!) {
      delete_category_by_pk(id: $id){
        title
        id
      }
    }
    `
    var variables = {
      'id': id
    }
    authedQuery(query, variables, cb)
  }
  updateCategoryContent(variables, cb) {
    var query = `
    mutation update_category_content($id: uuid!, $content: jsonb!) {
      update_category_by_pk(pk_columns: {id: $id}, _set: {content: $content}){
        id
        title
        description
      }
    }`
    authedQuery(query, variables, cb)
  }
  questionOrderMutationBuilder(value, index) {
    return `
    order_${index}: update_question (where: {id: {_eq: "${value}"}} , _set: {order: ${index+1}}) {
      affected_rows
      returning {
        order
        id
      }
    } `
  }
  updateQuestionOrder(mutations, cb) {
    var variables={}
    var template_query=`mutation update_question_order{
      ${mutations}
    }`
    authedQuery(template_query, variables, cb)
  }
  getQuestion(id, cb){
    var query = `query($id:uuid!) {
      question:question_by_pk(id: $id) {
        id
        question
        question_type
        choices
        correct_answers
        provide_explanation
        explanation
    }}`
    var variables = {
      'id': id
    }
    authedQuery(query, variables, cb)
    
  }
  getCategoriesForTutorials(cb){
    var query = `query {
      tutorials_by_category {
        id
        title
        tutorial_id
        tutorial_title
    }}`
    var variables = {
      
    }
    authedQuery(query, variables, cb)
    
  }
  getCategoriesForTutorial(id, cb){
    var query = `query($id:String!) {
      tutorials_by_category(where: {tutorial_id: {_eq: $id}}) {
        id
        title
    }}`
    var variables = {
      'id': id
    }
    authedQuery(query, variables, cb)
    
  }
  getCategoriesForQuiz(id, cb){
    var query = `query($id:uuid!) {
      quizzes_by_category(where: {quiz_id: {_eq: $id}}) {
        id
        title
        category{
          content
        }
    }}`
    var variables = {
      'id': id
    }
    authedQuery(query, variables, cb)
    
  }
  
  getCategories (variables, cb) {
    var query = `
    query categories {
      category(order_by: {title: asc}) {
        id
        title
        created_at
        description
        category_author_id
        kb: knowledge_bases_categories {
          knowledge_base_id
        }
        content
      }
    }
    `
    authedQuery(query, variables, cb)
  }

  newCategory (variables, cb) {
    var query = `
    mutation insert_category($organization_id: uuid!, $title: String!, $description: String!, $category_author_id: uuid!) {
      insert_category_one(object: {
        organization_id: $organization_id,
        title: $title,
        description: $description,
        category_author_id: $category_author_id
      }) {
        id
        organization_id
        title
        description
        created_at
        category_author_id
      }
    }`
    authedQuery(query, variables, cb)
  }
  updateCategoryMembership (variables, cb) {
    var query = `
    mutation update_category($id: uuid!, $idx: Int) {
      update_category_by_pk(pk_columns: {id: $id}, _delete_elem: {content: $idx}){
        id
        title
        content
      }
    }`
    authedQuery(query, variables, cb)
  }



  updateCategory (variables, cb) {
    var query = `
    mutation update_category($id: uuid!, $title: String!, $description: String!) {
      update_category_by_pk(pk_columns: {id: $id}, _set: {title: $title, description: $description}){
        id
        title
        description
      }
    }`
    authedQuery(query, variables, cb)
  }

  updateQuizActiveStatus (variables, cb) {
    var query = `
    mutation update_quiz($id: uuid!, $active: Boolean! ) {
      update_quiz_by_pk(pk_columns: {id: $id}, _set: {active: $active}){
        id
        active
      }
    }`
    authedQuery(query, variables, cb)
  }

  updateQuizDescription (variables, cb) {
    var query = `
    mutation update_quiz($id: uuid!, $title: String!, $description: String!, $time_to_complete: String! ) {
      update_quiz_by_pk(pk_columns: {id: $id}, _set: {title: $title, description: $description, time_to_complete: $time_to_complete}){
        id
        title
        description
        collect_user_information
      }
    }`
    authedQuery(query, variables, cb)
  }

  getQuizzes (variables, cb) {
      var query = `
      query get_quizzes($organization_id:uuid!) {
        quiz(order_by: {active: desc, title:asc}, where: {organization_id: {_eq: $organization_id}}
          ) {
          id
          title
          created_at
          description
          active
          quiz_author_id
          questions {
            order
            id
          }
        }
      }
      `
    authedQuery(query, variables, cb)
  }

  getKnowledgeBases (variables, cb) {
    var query = `
    query get_kbs($organization_id:uuid!) {
      knowledge_base(where: {organization_id: {_eq: $organization_id}}) {
        id
        title
        created_at
        description
      }
    }
    `
  authedQuery(query, variables, cb)
}

  getCategory(id, cb){
    var query = `query($id:uuid!) {category(where: {id: {_eq: $id}}) {
      id
      title
      description
      content
      category_author_id
    }}`
    var variables = {
      'id': id
    }
    authedQuery(query, variables, cb)
    
  }

  /* Feed the quiz results graph */
  getQuizSummaryResults(id, cb){
    var query = `query($id:uuid!) {
      quiz_results_summary(where: {quiz_id: {_eq: $id}}) {
        count
        dater
        result
    }}`
    var variables = {
      'id': id
    }
    authedQuery(query, variables, cb)
    
  }
  getQuizWithResults(id, cb){
    var query = `query($id:uuid!) {quiz(where: {id: {_eq: $id}}) {
      id
      title
      description
      collect_user_information
      minimum_correct_answers_to_pass
      time_to_complete
      total_pass:quiz_results_aggregate(where: {result: {_eq: true}}){
        aggregate{
          count
          avg{
            score
          }
        }
      }
      averager:quiz_results_aggregate{
        aggregate{
          count
          avg{
            score
          }
        }
      }
      quiz_results (order_by:{created_at:desc}) {
          id
          created_at
          score
          result
          name
          email
      }
      
    }}`
    var variables = {
      'id': id
    }
    authedQuery(query, variables, cb)
    
  }
  getOrganizationAccessPolicy(organization_id, cb){
    var query = `query($id:uuid!) {organization(where: {id: {_eq: $id}}){
      protected_content_policy
    }}`
    var variables = {
      'id': organization_id
    }
      anonymousQuery(query, variables, cb)
  }
  getQuiz(id, cb){
    var query = `query($id:uuid!) {quiz(where: {id: {_eq: $id}}) {
      id
      title
      description
      collect_user_information
      minimum_correct_answers_to_pass
      time_to_complete
      quiz_categories{
        id
        title
      }
      questions_aggregate {
        aggregate {
          count
        } 
      }
      questions(order_by: {order: asc}){
        id
        question
        question_type
        explanation
        choices
        correct_answers
        order
      }
    }}`
    var variables = {
      'id': id
    }
      authedQuery(query, variables, cb)    
  }
  getQuizForQuizTaker(id, cb){
    var query = `query($id:uuid!) {quiz(where: {id: {_eq: $id}}) {
      id
      title
      description
      active
      collect_user_information
      minimum_correct_answers_to_pass
      time_to_complete
      quiz_categories{
        id
        title
      }
      questions_aggregate {
        aggregate {
          count
        } 
      }
      questions(order_by: {order: asc}){
        id
        question
        question_type
        explanation
        choices
        correct_answers
        order
      }
    }}`
    var variables = {
      'id': id
    }
    anonymousQuery(query, variables, cb)    
  }
  updateQuestion (variables, cb){
    var query = `
    mutation update_question($id:uuid!, $choices:jsonb, $correct_answers:jsonb, $provide_explanation:Boolean!, $explanation:String, $question:String!, $question_type:String! ) {
      update_question_by_pk(pk_columns: {id: $id}, _set: {
        choices: $choices, 
        correct_answers:$correct_answers, 
        provide_explanation:$provide_explanation, 
        explanation:$explanation,
        question_type:$question_type, 
        question:$question}) {
        id
      }
    }
    `
    authedQuery(query, variables, cb)
  }
  insertQuizResult (variables, cb){
    var query = `
    mutation insert_quiz_result($quiz_id:uuid!, $name:String!, $email:String!, $score:Int!,$result:Boolean!,$answers:jsonb  ) {
      insert_quiz_result_one(object: {
        quiz_id:$quiz_id, 
        name:$name,
        email:$email,
        score:$score,
        result:$result
        answers:$answers,
        }) {
        id
      }
    }
    `
    authedQuery(query, variables, cb)
  }
  insertQuestion (variables, cb){
    var query = `
    mutation insert_question($quiz_id:uuid!, $choices:jsonb, $correct_answers:jsonb, $provide_explanation:Boolean!, $explanation:String, $question:String!, $question_type:String!, $order:Int ) {
      insert_question_one(object: {
        quiz_id:$quiz_id, 
        choices: $choices, 
        correct_answers:$correct_answers,
        provide_explanation:$provide_explanation,  
        explanation:$explanation, 
        question:$question, 
        question_type: $question_type
        order: $order}) {
        id
      }
    }
    `
    authedQuery(query, variables, cb)
  }
  deleteQuestion (id, cb){
    var query = `
    mutation delete_question($id:uuid! ) {
      delete_question_by_pk(id: $id){
        id
      }
    }
    `
    var variables = {
      'id': id
    }
    authedQuery(query, variables, cb)
  }

  newQuiz (variables, cb) {
    var query = `
    mutation insert_quiz($organization_id: uuid!, $title: String!, $description: String!, $time_to_complete: String!, $quiz_author_id: uuid!) {
      insert_quiz_one(object: {
        organization_id: $organization_id,
        title: $title,
        description: $description,
        time_to_complete: $time_to_complete,
        quiz_author_id: $quiz_author_id
      }) {
        id
        organization_id
        title
        description
        time_to_complete
        created_at
        quiz_author_id
      }
    }`
    authedQuery(query, variables, cb)
  }

  

  updateQuiz (variables, cb) {
    var query = `
    mutation update_quiz($id: uuid!, $collect_user_information: String!) {
      update_quiz_by_pk(pk_columns: {id: $id}, _set: {collect_user_information: $collect_user_information}){
        id
        title
        collect_user_information
      }
    }`
    authedQuery(query, variables, cb)
  }

  updateQuizPassCorrectAnswers (variables, cb) {
    var query = `
    mutation update_quiz($id: uuid!, $minimum_correct_answers_to_pass:Int!) {
      update_quiz_by_pk(pk_columns: {id: $id}, _set: {minimum_correct_answers_to_pass: $minimum_correct_answers_to_pass}){
        id
        title
        minimum_correct_answers_to_pass
      }
    }`
    authedQuery(query, variables, cb)
  }
  
  deleteQuiz (id, cb) {
    var query = `
    mutation delete_quiz($id: uuid!) {
      delete_quiz_by_pk(id: $id){
        title
        id
      }
    }
    `
    var variables = {
      'id': id
    }
    authedQuery(query, variables, cb)
  }
  

  onChange () { } 
}

gqlV2Query.install = function (Vue, options) {
  Object.defineProperty(Vue.prototype, '$gqlV2Query', {
    get () { return this.$root._gqlV2Query }
  })
}



// WEBPACK FOOTER //
// ./src/plugins/gqlV2/gql.js